import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  title: 'Wniosek',
  type: 'object',
  properties: {
    application: {
      type: 'object',
      title: 'Wniosek',
      properties: {
        type: {
          type: 'string',
          enum: ['NEW', 'EXTENSION'],
          default: 'NEW'
        },
        firstName: {
          title: 'Imię *',
          type: 'string',
          fieldRequired: true
        },
        lastName: {
          title: 'Nazwisko *',
          type: 'string',
          fieldRequired: true
        },
        email: {
          title: 'Adres e-mail',
          type: 'string',
          fieldRequired: false
        },
        phoneNumber: {
          title: 'Numer telefonu (opcjonalne)',
          type: 'string',
          fieldRequired: false
        },
        birthDate: {
          title: 'Data urodzenia *',
          type: 'string',
          format: 'date',
          fieldRequired: true,
          validationMessages: {
            format: 'Nieprawidłowy format. Przykład: 01.01.1990'
          }
        },
        woj: {
          title: 'Województwo *',
          type: 'string',
          fieldRequired: true
        },
        pow: {
          title: 'Powiat *',
          type: 'string',
          fieldRequired: true
        },
        gmi: {
          title: 'Gmina *',
          type: 'string',
          fieldRequired: true
        },
        terc: {
          title: 'Kod TERC',
          type: 'string',
          fieldRequired: true,
          minLength: 6
        },
        city: {
          title: 'Miejscowość *',
          type: 'string',
          fieldRequired: true
        },
        simc: {
          title: 'Kod SIMC',
          type: 'string',
          fieldRequired: true
        },
        street: {
          title: 'Ulica *',
          type: 'string',
          fieldRequired: true
        },
        ulic: {
          title: 'Kod ULIC',
          type: 'string',
          fieldRequired: false
        },
        postalCode: {
          title: 'Kod pocztowy *',
          type: 'string',
          format: 'kod',
          fieldRequired: true,
          validationMessages: {
            format: 'Niepoprawny kod pocztowy'
          }
        },
        homeNumber: {
          title: 'Numer budynku *',
          type: 'string',
          fieldRequired: true
        },
        localNumber: {
          title: 'Numer lokalu',
          type: 'string',
          fieldRequired: false
        },
        profileId: {
          type: 'number',
          fieldRequired: true
        },
        collectionPointId: {
          title: 'Punkt wydawania kart *',
          type: 'number',
          fieldRequired: true,
          disabled: `!this.physical`
        },
        media: {
          type: 'array',
          items: { type: 'number' },
          minItems: `!!this.physicalAttachments ? 0 : 1`,
          validationMessages: {
            minItems: 'Wymagany jest przynajmniej jeden załącznik.'
          }
        },
        virtual: {
          title: 'Chcę kartę elektroniczną',
          type: 'boolean',
          default: true,
          computed: true
        },
        physical: {
          title: 'Chcę kartę fizyczną',
          type: 'boolean',
          default: false,
          fieldRequired: false
        },
        groups: {
          type: 'array',
          items: {
            type: 'number'
          }
        },
        termIds: {
          type: 'array',
          items: { type: 'number' },
          calc: [
            'var selectedTerms = [];',
            'var keys = Object.keys(this.terms);',
            'for (var i = 0; i < keys.length; i++) {',
            '  var key = keys[i];',
            '  if (this.terms[key]) {',
            '    selectedTerms.push(parseInt(key.replace("term_", "")));',
            '  }',
            '}',
            'return selectedTerms;'
          ]
        },
        terms: {
          computed: true,
          type: 'object',
          properties: {}
        },
        physicalAttachments: {
          default: false,
          title: 'Okażę w punkcie wydawania kart',
          type: 'boolean'
        }
      }
    }
  }
};
